import { render } from "./AverageSpeedOfAnswer.vue?vue&type=template&id=98ae727c&ts=true"
import script from "./AverageSpeedOfAnswer.vue?vue&type=script&lang=ts"
export * from "./AverageSpeedOfAnswer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__